import React, { FC, useMemo } from "react";
import * as d3 from "d3";

import { LineChartTooltipStyles, StyledLineChart } from "./styled";

import { useRenderLineTooltip } from "./hooks/useRenderLineTooltip";
import { getGradientColors } from "./utils/getGradientColors";

import { ChatChartProps } from "./types";

export const LineChart: FC<ChatChartProps> = ({ chartData }) => {
  const renderTooltip = useRenderLineTooltip();

  const gradientColors = useMemo(() => {
    return getGradientColors(chartData.labels.length);
  }, [chartData]);

  return (
    <>
      <LineChartTooltipStyles />
      <StyledLineChart
        data={chartData.datasets.map((item, itemIndex) => ({
          values: item.data,
          stroke: gradientColors[itemIndex],
        }))}
        curve={d3.curveBasis}
        labels={chartData.labels}
        xScaleItemWidth={100}
        drawGridX
        dynamicTooltipEnable
        height={250}
        stacked={false}
        renderTooltip={(datas, properties) => renderTooltip(datas, properties, chartData.labels)}
        tooltipClassName="lineChartTooltip"
        margin={{
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        }}
      />
    </>
  );
};
